/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, OnChanges, SimpleChanges, Output } from '@angular/core';
import { SysqueDropdownConnectorsVM } from '../../models/sysque-dropdown-connectors-vm';
import { DropDownOptions } from '../../models/sysque-dropdown-vm';
import { getMaxContentWidth } from '../../utils/common.utils';

@Component({
  selector: 'sysque-dropdown-connectors',
  templateUrl: './sysque-dropdown-connectors.component.html',
  styleUrls: ['./sysque-dropdown-connectors.component.scss'],
  standalone: false
})
export class SysqueDropdownConnectorsComponent implements OnChanges {
  @Input() title: string;
  @Input() connectors: SysqueDropdownConnectorsVM[];
  @Output() valueChanged: EventEmitter<{ value: string, label: string, index: number }> = new EventEmitter<{ value: string, label: string, index: number }>();
  @Output() getLink = new EventEmitter<string>();
  public items: SysqueDropdownConnectorsVM[] = [];
  public dropDownOptions: DropDownOptions;
  public hasTitle: boolean = false;
  private calculatedWidth: string = 'auto';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['connectors'] && this.connectors) {
      this.hasTitle = this.title !== undefined && this.title !== '';
      this.items = this.connectors.map(item => {
        this.calculatedWidth = getMaxContentWidth(item.data);
        this.dropDownOptions = {
          width: this.calculatedWidth,
          resizeEnabled: true,
          maxWidth: 500
        };
        return {
          label: item.label,
          data: item.data,
          placeholder: item?.placeholder !== undefined ? item.placeholder : 'Connector',
          selectedValue: item?.selectedValue !== undefined ? item.selectedValue : item.data[0],
          width: item?.width !== undefined ? item.width : '100%',
          height: item?.height !== undefined ? item.height : '30px'
        };
      });
    }
  }

  public onClick(): void {
    this.getLink.emit();
  }

  public onValueChanged($event: string, label: string, index: number): void {
    this.valueChanged.emit({ value: $event, label: label, index: index });
  }
}